import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function ValueAnchorSection() {
  const items = [{
    label: 'Sesiones individuales de coaching',
    value: '+$45.000'
  }, {
    label: 'Formación aplicada en regulación emocional',
    value: '+$25.000'
  }, {
    label: 'Guías prácticas y audios guiados',
    value: '+$18.000'
  }, {
    label: 'Herramientas estructuradas de higiene energética',
    value: '+$22.000'
  }];
  return <SectionWrapper data-id="element-135">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-136">
        <h2 className="text-3xl md:text-4xl text-text mb-12" data-id="element-137">
          Si accedieras a estas herramientas por separado…
        </h2>

        <div className="space-y-5 mb-12" data-id="element-138">
          {items.map((item, index) => <div key={index} className="flex items-center justify-between border-b border-border-custom pb-4" data-id="element-139">
              <span className="text-text-secondary text-left" data-id="element-140">
                {item.label}
              </span>
              <span className="text-text font-medium ml-4 flex-shrink-0" data-id="element-141">
                {item.value}
              </span>
            </div>)}
        </div>

        <p className="text-2xl md:text-3xl font-serif text-text mb-6" data-id="element-142">
          Valor estimado total:{' '}
          <span className="font-bold" data-id="element-143">más de $70.000</span>
        </p>

        <p className="text-lg text-text-secondary mb-4" data-id="element-144">
          Eso es lo que costaría acceder a esto por separado.
        </p>

        <p className="text-xl md:text-2xl text-text-secondary" data-id="element-145">
          Pero decidimos hacerlo accesible por lanzamiento.
        </p>
      </div>
    </SectionWrapper>;
}